import { render } from "./IconWifi.vue?vue&type=template&id=9222a10a"
const script = {}

import exportComponent from "/home/balluff-sales-applinksderisario/sales-app.balluff.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__